import { Button, Descriptions, Dropdown, Popconfirm, Table, Tabs } from "antd";
import { useNavigate, useParams, useRouteLoaderData } from "react-router";
import { DeleteOutlined, EditOutlined, MoreOutlined } from "@ant-design/icons";
import BackTitle from "../common/BackTitle";
import { api } from "../common/api";

const requirementGroups = [
  { key: "requiredEquipments", label: "Attrezzature richieste", type: "equipmentType" },
  { key: "requiredMansions", label: "Mansioni richieste", type: "mansion" },
  { key: "requiredVehicles", label: "Veicoli richiesti", type: "vehicleType" },
  { key: "requiredDpis", label: "DPI richiesti", type: "dpi" },
  { key: "requiredAppointments", label: "Nomine richieste", type: "appointmentType" },
];

export default function WorkActivity() {
  const navigate = useNavigate();
  const data = useRouteLoaderData("workActivity");
  const { id } = useParams();

  return (
    <div style={{ width: "100%" }}>
      <BackTitle
        backEnabled={false}
        title="Dettagli attività lavorativa"
        secondary={`ID: ${id}`}
        extra={
          <Dropdown
            trigger={["click"]}
            menu={{
              items: [
                {
                  key: "deleteWorkActivity",
                  label: (
                    <Popconfirm
                      title="Conferma rimozione"
                      onConfirm={() => api.workActivity.delete(id).then(() => navigate(".."))}
                      description="L'operazione è irreversibile. Procedendo, i dati verranno rimossi definitivamente."
                    >
                      Elimina
                    </Popconfirm>
                  ),
                  danger: true,
                  icon: <DeleteOutlined />,
                },
              ],
            }}
          >
            <Button aria-label="Azioni attività lavorativa" icon={<MoreOutlined />} />
          </Dropdown>
        }
      />
      <Descriptions
        layout="vertical"
        title={
          <>
            Informazioni generali
            <Button
              type="link"
              aria-label="Modifica attività lavorativa"
              icon={<EditOutlined />}
              onClick={() => navigate("edit")}
            />
          </>
        }
        column={3}
        colon={false}
        items={[{ key: "name", label: "Nome", children: data.name }]}
      />
      <Tabs
        items={requirementGroups.map(({ key, label, type }) => ({
          key,
          label,
          children: (
            <Table
              rowKey="id"
              dataSource={data[key] ?? []}
              pagination={false}
              locale={{ emptyText: "Nessun requisito" }}
              columns={[
                { title: "Nome", dataIndex: [type, "name"], key: "name" },
                { title: "Quantità minima", dataIndex: "minCount", key: "minCount", width: 160 },
                ...(key === "requiredDpis"
                  ? [{
                      title: "Politica",
                      dataIndex: "countPolicy",
                      key: "countPolicy",
                      render: (policy) =>
                        ({ INDIVIDUAL: "Ciascuno", ABSOLUTE: "Condiviso" }[policy] ?? policy ?? "—"),
                    }]
                  : []),
              ]}
            />
          ),
        }))}
      />
    </div>
  );
}
